import { navigate } from '@reach/router'

const httpRequest = async (url, method, body, signal) => {
  const token = localStorage.getItem('token')
  const response = await fetch(`https://admin.saikiseva.com${url}`, {
    method,
    headers: {
      'Content-Type': 'application/json',
      authorization: token || '',
    },
    body: JSON.stringify(body),
    signal,
  })

  const data = await response.json()
  const headers = await response.headers

  /**
   * handle "Invalid credentials" error from the API
   */
  if (data.error && data.error.errorCode === 'AUTH021') {
    await navigate('/login')
    return null
  }

  return { data, headers }
}

export default httpRequest
